export enum TrackingAction {
  SSROrderIssueSelected = 'ssr_order_issue_selected',
}

export enum HelpCentre {
  HELP_CENTRE_SEARCH_CLICK = 'help_centre_search_click',
  HELP_CENTRE_SEARCH_CONTACT_US = 'help_centre_search_contact_us',
  HELP_CENTRE_SEARCH_ARTICLE_CLICK = 'help_centre_search_article_click',
  HELP_CENTRE_SEARCH_SHOW_RESULTS = 'help_centre_search_show_results',
}
